<template>
  <v-app id="inspire">
    <Header type="search-crm"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-11">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Напоминание о задачах пользователя</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Монитор продаж / Напоминание о задачах пользователя </span> </div>
                </div>
                       <button
                           v-if="operationType"
                            @click="saveOperation()"
                            class="button button__success"
                            style="margin-left:15px;"
                        >
                          Сохранить изменения
                        </button>
                        <button
                           v-else
                            class="button button__secondary"
                            style="margin-left:15px;"
                        >
                          Сохранить изменения
                        </button>
              </v-col>
            </v-row>

       
              <v-row style="margin:0px; margin-top:30px; background-color: #fff; border-top-left-radius:12px; border-top-right-radius:12px;">
                <v-col class="mt-5 col-12" style="margin-top:0px !important;">
                  <div class="d-flex" style="align-items: center;">
     
                   
                    <div style="margin-left: 20px;">
                      <v-btn
                          v-if="operationType && operationType === 1"
                          class="button__success"
                          @click="operationType = null"
                      >
                      <v-icon
                                large
                                class="mr-2"
                                style="font-size:24px;"
                            >
                              mdi-clock-time-four-outline
                            </v-icon>

                        Отложить
                      </v-btn>
                      <v-btn
                          v-else
                          class="button__lighten"
                          @click="(choosedTasks && choosedTasks.length > 0) ? (operationType = 1) : null"
                      >
                      <v-icon
                                large
                                class="mr-2"
                                style="font-size:24px;"
                            >
                              mdi-clock-time-four-outline
                            </v-icon>
                        Отложить
                      </v-btn>
              
                      <v-btn
                          v-if="operationType && operationType === 2"
                          class="button__success"
                          style="margin-left:10px; margin-right:10px;"
                          @click="operationType = null"
                      >
                        Выполнено
                      </v-btn>
                      <v-btn
                          v-else
                          class="button__lighten"
                          style="margin-left:10px; margin-right:10px;"
                          @click="(choosedTasks && choosedTasks.length > 0) ? (operationType = 2) : null"
                      >
                        Выполнено
                      </v-btn>


                      <v-btn
                          v-if="operationType && operationType === 3"
                          class="button__success"
                          @click="operationType = null"
                      >
                        Больше не показывать
                      </v-btn>
                      <v-btn
                          v-else
                          class="button__lighten"
                          @click="(choosedTasks && choosedTasks.length > 0) ? (operationType = 3) : null"
                      >
                        Больше не показывать
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>

            <v-data-table
            v-if="tasksList"
                          :headers="headersTasks"
                          :items="tasksList ? tasksList : []"
                          :page="pageLessons"
                          no-data-text="Список не найден"
                          class="elevation-1"
                          style="width:100%;"
                      >
                        <!-- <template v-slot:item.start_date="{item}">
                          <router-link :to="{ name: 'Lesson', params: { appointment_id: item.id} }" style="text-decoration: none; color: black">
                            {{ item.start_date }}
                          </router-link>
                        </template> -->
                        <template v-slot:item.theme="{item}">
                          <div class="tabr" v-class="{active: isActive}" @dblclick="openTask(item)" @click="chooseTask(item,$event)">

                            <div style="width:50%;">{{ item.theme }} ({{ item.description }}) </div>
                            <div style="width:50%; display:flex; justify-content: flex-end; ">
                              <div>{{ item.time_end ? (item.time_end.split('T')[1] ? (item.time_end.split('T')[0] + ' ' + item.time_end.split('T')[1]) : item.time_end) : '' }}</div>
                              <div style="margin-left:10px;">
                                  <span v-if="item.remind === 1" style="color:orange;">
                                    В момент события
                                  </span>
                                  <span v-else>
                                    Не напоминать
                                  </span>
                              </div>
                            </div>

                          </div>
                        </template>
         
                      </v-data-table>
                      <!-- <v-card-actions
                          class="d-flex justify-content-between"
                          style="padding: 20px !important;"
                          v-if="scheduleList && scheduleList.data && scheduleList.data.length > 10"
                      >
                        <div></div>
                        <div>
                          <v-pagination
                              v-model="pageLessons"
                              circle
                              color="#629F33"
                              :length="scheduleList.paginationLength"
                              :total-visible="6"
                          ></v-pagination>
                        </div>
                      </v-card-actions> -->


 

          </v-container>
        </v-row>

        <v-row justify="center">
              <v-dialog
                  v-model="modalHistory"
                  max-width="800px"
              >
                <v-card rounded="lg" v-if="modalHistory">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4> История </h4>
                    </div>
                    <v-btn icon @click="modalHistory = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="padding-left: 0px !important; padding-right: 0px !important;">
          
                      <div>
                        <v-data-table
                            v-if="productInfo && productInfo.data && productInfo.data.statuses"
                            :headers="headersHistory"
                            :items="productInfo.data.statuses"
                            item-key="id"
                            item-value="id"
                            v-model="selectTag"
                            no-data-text="Ничего не найдено"
                            hide-default-footer
                            disable-pagination
                            class="elevation-1"
                        >
                        <template v-slot:item.date="{ item }">
                          {{ item.date.split('T')[0] }}
                        </template>

                        <template v-slot:item.document="{ item }">
                          {{ item.date.split('T')[1] }}
                        </template>

                        <template v-slot:item.status="{ item }">
                          <span v-if="item.user">{{ item.user }}</span>
                          <span v-else> web </span>
                        </template>

                        <template v-slot:item.document.name="{ item }">
                          {{ item.status + ' ' +  item.document.name}}
                        </template>

                        </v-data-table>
                     
                      </div>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>

            <v-row justify="center">
              <v-dialog
                  v-model="modalDelete"
                  max-width="500px"
              >
                <v-card rounded="lg" v-if="modalDelete">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                    </div>
                    <v-btn icon @click="modalDelete = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="">
          
                      <div style="padding:20px; font-size:20px; font-weight: bold; color:#000;">

                        Пометить {{ productInfo.data.name  }} на удаление?
                     
                      </div>

                      <v-row class="mt-5">
                          <v-card-actions style=" width:100%; display: flex; align-items: center; justify-content: center; padding-bottom: 20px;">
                            <button
                                class="button button__success"
                                ref="activator"
                                style="width:106px; height: 48px;"
                                @click="modalDelete = false"
                            >
                              Да
                            </button>
                            <button
                                class="button button__lighten"
                                ref="activator"
                                style="width:106px; height: 48px; color:#000; margin-left:15px;"
                                @click="modalDelete = false"
                            >
                              Нет
                            </button>
                          </v-card-actions>
                        </v-row>

                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>


            <v-row justify="center">
              <v-dialog
                  v-model="dialogEditTask"
                  max-width="900px"
              >
                <v-card rounded="lg" v-if="editTask">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>{{ editTask.topic }}</h4>
                    </div>
                    <v-btn icon @click="dialogEditTask = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="editTaskForm" @submit.prevent="editTaskSubmit">
                        <v-row
                            class="mt-5"
                        >
                          <v-col
                              cols="12"
                              sm="6"
                              md="6"
                              v-if="editTask.deal && editTask.deal.length > 0"
                              style="display:flex; align-items:center; justify-content: space-between;"
                          >
                          <div style="width:30%;">
                            <label>Сделка</label>
                            <v-select
                                class="rounded-lg custom__select"
                                v-model="editTask.deal"
                                :items="visitorDesktop.client.activeDeals"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                placeholder="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </div>
                          <div style="width:40%;">
                  

                            <router-link v-if="editTask.client" :to="{ name: 'CardClient', params: { client_id: editTask.client.id} }" style="text-decoration: none; color: black">
                              {{editTask.client.name}}
                              ({{editTask.client.status}})
                            </router-link>

                          </div>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              v-if="listTask"
                              style="display:flex; align-items:center; justify-content: space-between;"
                          > 
                          <div style="width:30%;">
                            <label>Вид задачи</label>
                            <v-select
                                class="rounded-lg custom__select"
                                v-model="editTask.type_id"
                                :items="listTask.monitor"
                                item-value="name"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                placeholder="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>

                          </div>

                          <div style="width:40%;">
                            <router-link v-if="editTask.client" :to="{ name: 'CardClientNew', params: { client_id: editTask.client.id} }" style="text-decoration: none; color: black">
                              {{editTask.client.name}}
                              ({{editTask.client.status}})
                            </router-link>
                          </div>

                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Тема задачи</label>
                            <v-text-field
                                v-model="editTask.topic"
                                placeholder="Тема задачи"
                                class="rounded-lg"
                                outlined
                                dense
                                style="height: 48px;"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="12"
                              md="12"
                          >
                            <label>Описание</label>
                            <v-textarea
                                v-model="editTask.description"
                                placeholder="Описание"
                                rounded
                                outlined
                                dense
                                required
                                auto-grow
                                background-color="#fff"
                                rows="5"
                                style="width: 100%; height: 150px"
                            ></v-textarea>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                              cols="12"
                              md="1"
                              class="d-flex align-center justify-center"
                          >
                            <v-icon
                                large
                                class="mr-2"
                            >
                              mdi-clock-time-four-outline
                            </v-icon>
                          </v-col>
                          <v-col
                              cols="8"
                              md="5"
                          >
                          <VueDatePicker
                                no-title
                                no-header
                                color="#629f34"
                                v-model="editTask.assigned_to"
                                placeholder="Выбрать"
                            >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__datepicker"
                                    ref="activator"
                                    type="button"
                                >

                                  <div>
                                    <span v-if="editTask.assigned_to">{{ formatDateTime2(editTask.assigned_to) }}</span>
                                    <span v-else style="color: gray">Дата{{date}}</span>
                                  </div>
                                  <div>
                                    <v-icon
                                        medium
                                        right
                                        class="ml-5"
                                    >
                                      mdi-calendar-blank-outline
                                    </v-icon>
                                  </div>
                                </button>
                              </template>
                            </VueDatePicker>
                          </v-col>

                          <v-col
                              cols="4"
                              md="5"
                          >
                              <div style="display:flex; align-items:center;">
                                <v-select
                                      class="rounded-lg custom__select"
                                      v-model="editTask.time"
                                      :items="timeArray"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      placeholder="Время"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      style="height: 48px; margin-top:10px; width:120px; margin-right:10px;"
                                  ></v-select>


                                  <div v-if="editTask.notification_status === 0" 
                                  @click="editTask.notification_status = 1"
                                  style="display:flex; align-items:center; justify-content:center; width:170px; padding:10px; background:#e0e0e0; margin-left:10px; cursor:pointer; border-radius:10px;">
                                  <img src="/playground_assets/notifi_icon.svg" alt=""> 
                                  <span style="margin-left:10px;">Не напоминать </span>
                                  </div>
                                  <div v-else 
                                  @click="editTask.notification_status = 0"
                                  style="display:flex; align-items:center; justify-content:center; width:170px; padding:10px; background:#e0e0e0; margin-left:10px; cursor:pointer;  border-radius:10px;">
                                  <img src="/playground_assets/notifi_icon.svg" alt="">  
                                  <span style="margin-left:10px;">В момент события</span>
                                  </div>

                              </div>
                          </v-col>

                        </v-row>
                          
                        <v-row>

                            <v-col
                                cols="12"
                                md="12"
                            >
                            <div style="display:flex; align-items:center;">
                              <div style="display:flex; align-items:center; justify-content:center; padding:4px;">
                                <img src="/playground_assets/mediumuseri324-pp8g.svg" style="width: 30px;" alt="">
                              </div>
                                <v-select
                                v-if="editTask && editTask.user"
                                              class="rounded-lg custom__select"
                                              v-model="editTask.user.id"
                                              :items="specialist ? specialist.specialist : []"
                                              item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                              placeholder="Выбрать"
                                              append-icon="mdi-chevron-down"
                                              outlined
                                              dense
                                              style="height: 48px;margin-top: 10px;  margin-left:31px; width:40%;">
                                </v-select>
                                <v-select
                                v-else-if="editTask && editTask.specialist_id"
                                              class="rounded-lg custom__select"
                                              v-model="editTask.specialist_id.id"
                                              :items="specialist ? specialist.specialist : []"
                                              item-value="id"
                                              item-text="name"
                                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                              placeholder="Выбрать"
                                              append-icon="mdi-chevron-down"
                                              outlined
                                              dense
                                              style="height: 48px;margin-top: 10px;  margin-left:31px; width:40%;">
                                </v-select>

                                <div style="width:20%; font-size:16px; margin-left:20px;">
                                  Создана: {{ editTask.date_create ? (editTask.date_create.split('T')[1] ? (editTask.date_create.split('T')[0] + ' ' + editTask.date_create.split('T')[1]) : editTask.date_create) : '' }}
                                </div>

                                <v-btn
                                      v-if="editTask.done === false"
                                      class="button button__lighten"
                                      style="width:20%;"
                                      @click="modifyTask(editTask, true)"
                                  >
                                    
                                    Выполнена
                                  </v-btn>
                                  
                                <v-btn
                                      v-else
                                      class="button button__success"
                                      style="width:20%;"
                                      @click="modifyTask(editTask, false)"
                                  >
                         
                                    Выполнена
                                  </v-btn>
                            </div>
                            </v-col>
                        </v-row>

                        <!-- <v-row>
                          <v-col
                              cols="12"
                              md="1"
                              class="d-flex align-center justify-center"
                          >
                            <v-icon
                                large
                                class="mr-2"
                            >
                              mdi-clock-time-four-outline
                            </v-icon>
                          </v-col>
                          <v-col
                              cols="12"
                              md="5"
                          >
                            <VueDatePicker
                                no-title
                                no-header
                                color="#629f34"
                                v-model="editTask.assigned_to"
                                placeholder="Выбрать"
                            >
                              <template #activator="{ date }">
                                <button
                                    class="button custom__datepicker"
                                    ref="activator"
                                    type="button"
                                >

                                  <div>
                                    <span v-if="editTask.assigned_to">{{ formatDateTime(editTask.assigned_to) }}</span>
                                    <span v-else style="color: gray">Дата{{date}}</span>
                                  </div>
                                  <div>
                                    <v-icon
                                        medium
                                        right
                                        class="ml-5"
                                    >
                                      mdi-calendar-blank-outline
                                    </v-icon>
                                  </div>
                                </button>
                              </template>
                            </VueDatePicker>
                          </v-col>
  
                        </v-row> -->
                
                        <v-row>
                          <div style="margin-left: auto;">
                            <button
                                class="button button__danger mr-3"
                                type="button"
                                style="font-weight: 700; border-radius: 12px !important;"
                                @click="deleteTask(editTask)"

                            >
                              Удалить
                            </button>
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                                style="font-weight: 700;"
                            >
                              Сохранить
                            </button>
                          </div>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';
import {clientActionTypes} from "@/store/modules/client";
import {receptionActionTypes} from '@/store/modules/reception';
import {monitorActionTypes} from "@/store/modules/monitor";
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {lessonActionTypes} from "@/store/modules/lesson";
import {tasksActionTypes} from "@/store/modules/tasks";

export default {
  name: "ManagerTasks",
  props: ['client_id','attent'],
  components: {
    Header,
    Menu,
    VueDatePicker
  },
  data() {
    return {
      debtsAr:null,
      modalHistory:false,
      headersHistory:[
        {text: '', align: 'start', sortable: false, value: 'date'},
        {text: '', align: 'start', sortable: false, value: 'document'},
        {text: '', align: 'start', sortable: false, value: 'status'},
        {text: '', align: 'start', sortable: false, value: 'document.name'},
      ],
      modalDelete:false,
      contractList:[],
      isLoading2:false,
      headersTasks: [
        {text: 'Задача', align: 'start', sortable: false, value: 'theme'}
      ],
      tasksList:[],
      dialogEditTask:false,
      editTask: {
        id: 1,
        deal: null,
        type: null,
        topic: null,
        message: null,
        date: null,
        time: null,
        notification: false,
        manager: null,
        description:null,
        time:null,
        specialist_id:{
          id:getItem('user_id_1c'),
          name:getItem('fio')
        },
        notification_status:0,
        date_create:null,
        type_id:null,
        done:false,
        client:null
      },
      timeArray: [
          '00:00','00:30','01:00','01:30',
          '02:00','02:30','03:00','03:30','04:00','04:30','05:00','05:30','06:00','06:30',
          '07:00','07:30','08:00','08:30','09:00','09:30','10:00','10:30','11:00','11:30',
          '12:00','12:30','13:00','13:30','14:00','14:30','15:00','15:30','16:00','16:30',
          '17:00','17:30','18:00','18:30','19:00','19:30','20:00','20:30','21:00','21:30','22:00',
          '22:30','23:00','23:30'
        ],
        choosedTasks:[],
        operationType:null,
        isActive:false,
        typeTasks:[],
        pageLessons:20
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.client.isLoading,
      productInfo: state => state.client.productInfo,
      validationErrors: state => state.client.validationErrors,
      freezeList: state => state.client.freezeList,
      listTask: state => state.monitor.listTask,
      specialist: state => state.lesson.specialist
    })
  },
  mounted() {
    console.log(this.attent)
    if(this.attent) {
      setItem('tasks_opened',true)
    }
    this.client_id !== undefined ? setItem('user_id_1c', this.client_id) : this.client_id = getItem('user_id_1c');

    this.fetchFeed(this.client_id)
    this.$store.dispatch(lessonActionTypes.getSpecialistList);
    this.$store.dispatch(monitorActionTypes.getListTask)
          .then((response) => {
            if (response.success) {

                if(this.listTask){
                   
                  for(let i = 0; i < this.listTask.monitor.length; i++) {
                    this.typeTasks[this.listTask.monitor[i].name] = {id:this.listTask.monitor[i].id,name:this.listTask.monitor[i].name}
                  } 

                }
            }

            });

            this.$store.dispatch(monitorActionTypes.setOpened)
            window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    handleBeforeUnload(event) {
      // ✅ Ваш код перед закрытием
      console.log('Пользователь закрывает вкладку или перезагружает страницу');

      // Если нужно показать предупреждение:
      event.preventDefault();
      event.returnValue = ''; // Для большинства браузеров достаточно пустой строки
      this.$store.dispatch(monitorActionTypes.setOpened, {close:true})

      const FLASH_TIMEOUT = 20000;

      setTimeout(() => {
        this.$store.dispatch(monitorActionTypes.setOpened)
      }, FLASH_TIMEOUT);

    },
    beforeDestroy() {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    modifyTask(task,tip){
      console.log(task)
      console.log(tip)
      this.editTask.done = tip
    },
    saveOperation(){
      console.log(this.operationType)
      if(this.choosedTasks.length === 0){
        alert('Не выбрана ниодна задача!')
        return;
      }
      if(this.operationType === 3){

        let updStep = 0

        for(let i = 0; i < this.choosedTasks.length; i++) {

            this.$store.dispatch(tasksActionTypes.tasksEdit, {
              client_id: this.choosedTasks[i].client.id,
              task_id: this.choosedTasks[i].id,
              deal_id: this.choosedTasks[i].deal,
              type_id: this.typeTasks[this.choosedTasks[i].type],
              date_start: this.choosedTasks[i].assigned_from,
              date_end: this.choosedTasks[i].enddate,
              name: this.choosedTasks[i].theme,
              description: this.choosedTasks[i].description,
              status: false,
              time_end: this.choosedTasks[i].time_end,
              notification_status: 0,
              specialist_id: this.choosedTasks[i].user.id

            }).then((response) => {

              if (response && response.success) {

                updStep = updStep + 1
                
                if(updStep === this.choosedTasks.length) {
                  this.fetchFeed(this.client_id)
                }

              }

            });

        }
        


      }

      if(this.operationType === 2) {

        let updStep = 0

        for(let i = 0; i < this.choosedTasks.length; i++) {

            let task_id = this.choosedTasks[i].id
            let done = true
            this.$store.dispatch(tasksActionTypes.tasksCheck, {
              task_id,
              done
            })
                .then((response) => {
                  if (response.success) {
                    updStep = updStep + 1
                
                    if(updStep === this.choosedTasks.length) {
                      this.fetchFeed(this.client_id)
                    }
                  }
            });
        }

      }


    },
    formatDateTime2(date) {
      date = new Date(date);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();

      // const hours = date.getHours().toString();
      // const minutes = date.getMinutes().toString();

      return `${day}.${month}.${year}`;
    },
    formatDateTime(date) {
      date = new Date(date);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();

      const hours = date.getHours().toString();
      const minutes = date.getMinutes().toString();

      return `${day}.${month}.${year} ${hours}:${minutes}`;
    },
    formatDate(data) {
      
      let date = data.date_end
      let descr = ''

      if(data.date_end.split('T'[1])){
        date = data.date_end.split('T')[0] + ' ' + data.date_end.split('T')[1]
      }

      if(data.description) {
        descr = data.description
      }

      return descr

    },
    openTask(task){
      console.log(task)
      if(this.taskchecked) {
        return;
      }
      this.$store.dispatch(monitorActionTypes.getListTask)
          .then((response) => {
            if (response.success) {

                if(this.listTask){
                   
                for(let i = 0; i < this.listTask.monitor.length; i++) {
                  this.typeTasks[this.listTask.monitor[i].name] = {id:this.listTask.monitor[i].id,name:this.listTask.monitor[i].name}
                } 
                this.editTask.client_id = task.client.id;
                this.editTask.id = task.id;
                this.editTask.deal = task.deal;
                this.editTask.type = task.id;
                this.editTask.topic = task.theme;
                this.editTask.user = task.user;
                this.editTask.message = task.message ? task.message : (task.description ? task.description : ''),
                this.editTask.description = task.description ? task.description : '';
                this.editTask.date = (task.done && task.done !== false) ? task.date_end : this.formatDateTime(task.date);
                this.editTask.assigned_to = task.time_end
                this.editTask.date_create = task.date
                this.editTask.time = task.time_end.split('T')[1].split(':')[0] + ':' + task.time_end.split('T')[1].split(':')[1]
                this.editTask.type_id = task.type
                this.editTask.specialist_id = task.specialist_id ? task.specialist_id : task.user.id
                this.editTask.notification_status = task.remind
                this.editTask.done = task.done
                this.editTask.client = task.client
                this.dialogEditTask = true;
                // if(task.name.split('Звонок')[1]){
                //   this.editTask.type = "0055a2cb-5917-11e8-814d-9c5c8e747603"
                // } else {
                //   this.editTask.type = "0055a2ce-5917-11e8-814d-9c5c8e747603"
                // }
                console.log(this.editTask)
              }

            }
          });
    },
    chooseTask(item,evtarget){
      console.log(item)
      console.log(evtarget)
      console.log(evtarget.target.parentElement.classList)

      if(evtarget.target.parentElement.classList[0] === 'text-start'){
        evtarget.target.classList.toggle('active')
      } else {
        evtarget.target.parentElement.classList.toggle('active')
      }

      

      if (this.choosedTasks.findIndex(n => n.id === item.id) !== -1) {
        this.choosedTasks.splice(this.choosedTasks.findIndex(n => n.id === item.id),1);
      } else {
        this.choosedTasks.push(item)
      }

      console.log(this.choosedTasks)

    },
    editTaskModal(task) {
      console.log(task)
      if(this.taskchecked) {
        return;
      }
      this.$store.dispatch(monitorActionTypes.getListTask)
          .then((response) => {
            if (response.success) {
              this.editTask.id = task.id;
              this.editTask.deal = task.deal;
              this.editTask.type = task.id;
              this.editTask.topic = task.name;
              this.editTask.user = task.user;
              this.editTask.message = task.message ? task.message : (task.description ? task.description : ''),
              this.editTask.description = task.description ? task.description : '';
              this.editTask.date = (task.done && task.done !== false) ? task.date_end : this.formatDateTime(task.assigned_to);
              this.editTask.assigned_to = task.assigned_to
              this.editTask.date_create = task.date_create
              this.editTask.time = task.assigned_to.split('T')[1].split(':')[0] + ':' + task.assigned_to.split('T')[1].split(':')[1]
              this.editTask.type_id = task.type_id
              this.editTask.specialist_id = task.specialist_id ? task.specialist_id : task.user.id
              this.editTask.notification_status = task.remind
              this.dialogEditTask = true;
              if(task.name.split('Звонок')[1]){
                this.editTask.type = "0055a2cb-5917-11e8-814d-9c5c8e747603"
              } else {
                this.editTask.type = "0055a2ce-5917-11e8-814d-9c5c8e747603"
              }
              console.log(this.editTask)
            }
          });
    },
    editTaskSubmit() {
      console.log(this.typeTasks)
      if (this.$refs.editTaskForm.validate()) {
        this.$store.dispatch(tasksActionTypes.tasksEdit, {
          client_id: this.editTask.client_id,
          task_id: this.editTask.id,
          deal_id: this.editTask.deal,
          type_id: this.typeTasks[this.editTask.type_id],
          date_start: this.editTask.assigned_from,
          date_end: this.editTask.assigned_to,
          name: this.editTask.topic,
          description: this.editTask.description,
          status: false,
          time_end: this.editTask.assigned_to.split('T')[1] ? (this.editTask.assigned_to.split('T')[0]+'T'+this.editTask.time) : this.editTask.assigned_to+'T'+this.editTask.time,
          notification_status: this.editTask.notification_status,
          specialist_id: this.editTask.specialist_id,
          done:this.editTask.done
        }).then((response) => {
          if (response && response.success) {
       

            this.fetchFeed(this.client_id)

          } else {
            alert('ошибка обновления задачи!')
          }
          this.dialogEditTask = false;
        });
      }
    },
    checkTask(task_id, st) {

      let done = st
      this.taskchecked = true
      this.$store.dispatch(tasksActionTypes.tasksCheck, {
        task_id,
        done
      })
          .then((response) => {
            if (response.success) {
              this.$store.dispatch(receptionActionTypes.desktopClientSale, {
                client_id: this.client_id
              });
            }
            this.taskchecked = false
          });
    },
    deleteTask(task) {

      let task_id = task.id

      this.$store.dispatch(tasksActionTypes.tasksRemove, {
        task_id
      })
          .then((response) => {
            if (response.success) {
              this.fetchFeed(this.client_id)

            }
          });
    },
    fetchFeed(client_id){
      this.isLoading2 = true
      let specialist_id = client_id;

      this.tasksList = []
      this.$store.dispatch(monitorActionTypes.getOverdueTasks, {
                  specialist_id,
                  manager_type:true
                }).then((response2) => {
                if(response2 && response2.success){
                  for(let i = 0; i < response2.monitor.length; i++) {
                    //if(response2.monitor[i].done === false && response2.monitor[i].remind === 1){
                      this.tasksList.push(response2.monitor[i])
                   // }
                  }
                } else {
                  alert('Проблема при загрузке данных клиента!')
                }
              }) 
    },
    fetchFeedOld(client_id) {
      this.isLoading2 = true
      let specialist_id = client_id;

      this.tasksList = []

      let startdate = '2024-01-01 00:00:00'
      let enddate = '2028-01-01 00:00:00'
      let page = 1
      let limit = 20

      //this.$store.dispatch(receptionActionTypes.desktopClientSale, {client_id})
      this.$store.dispatch(monitorActionTypes.getNewTasks, {
        specialist_id,
          startdate,
          enddate,
          page,
          limit
      })
      .then((response) => {
        if(response && response.success){
          this.isLoading2 = false
            if(response.monitor){

              if(response.monitor){
                for(let i = 0; i < response.monitor.length; i++) {
                  if(response.monitor[i].done === false && response.monitor[i].remind === 1){
                    //response.client.crm.today[i].toogled = false
                    this.tasksList.push(response.monitor[i])
                  }
                }
              }

              console.log(this.tasksList)

            }
           

                

                this.$store.dispatch(monitorActionTypes.getOverdueTasks, {
                  specialist_id,
                    startdate,
                    enddate,
                    page,
                    limit
                }).then((response2) => {
                if(response2 && response2.success){
                  for(let i = 0; i < response2.monitor.length; i++) {
                    if(response2.monitor[i].done === false && response2.monitor[i].remind === 1){
                      this.tasksList.push(response2.monitor[i])
                    }
                  }
                }
              }) 

              this.choosedTasks = []
                this.operationType = null

                this.editTask.id = null;
                this.editTask.type = null;
                this.editTask.date = null;
                this.editTask.topic = null;
                this.editTask.message = null;
                this.editTask.description = null;
                this.editTask.specialist_id = null;
                this.dialogEditTask = false;


        } else {
          alert('Проблема при загрузке данных клиента!')
      
        }
      })  
    },
    getClass(status) {
      if (status === 'Активен') return 'button__block'
      else if (status === 'Заморожен') return 'button__unblock'
      else if (status === 'Закрыт') return 'button__disabled'
      else if (status === 'Продан') return 'button__activate'
    },
    getRoute(status,product_id){
      if (status === 'Активен') return  {name: 'FreezePackage', params: {client_id: this.client_id, product_id: product_id}}
      else if (status === 'Заморожен')  return  {name: 'UnfreezePackage', params: {client_id: this.client_id, product_id: product_id}}
      else {return {}}
    },
    getNameStatus(status){
      if (status === 'Активен') return 'Заморозить'
      else if (status === 'Заморожен') return 'Разморозить'
      else if (status === 'Продан') return 'Активировать'
      else if (status === 'Закрыт') return 'Закрыт'
    },
    activateProduct(item){
      this.$store.dispatch(clientActionTypes.activateProduct, {
        product_id: item,
        client_id:this.client_id
      })
          .then(() => {
            if (this.tab === 4) {
              this.$store.dispatch(clientActionTypes.getMembership, {
                client_id: this.client_id,
              });
            }
            if (this.tab === 8) {
              this.$store.dispatch(clientActionTypes.getPacks, {
                client_id: this.client_id,
              });
            }
          })
    },
  },
  destroyed: function(){
    setItem('tasks_opened',null)
    this.$store.dispatch(monitorActionTypes.setOpened, {close:true})
  },
}
</script>

<style scoped>
.tabr {
  cursor: pointer;
  width:auto;
  height:100%;
  display: flex;
  align-items: center;
  margin-left:-16px;
  padding-left: 15px;
  padding-right: 15px;
  max-width: initial;
  margin-right:-16px;
}
.tabr:hover{
  background-color: #E0ECD6;
}
.tabr.active{
  background-color: #E0ECD6;
}

.toogled {
  background-color: #E0ECD6;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding:0px !important;
}

.vd-activator .custom__datepicker {
  width: 89% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: space-between !important;
  margin-top: 9px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}

</style>